import React from 'react';
import PropTypes from 'prop-types';
import { isWHWPhase2Flag } from "../../../common/Helpers"
import { isWHWPlusSPO } from "../NextBillsUtils"
import { Subtext } from './NBSView.styles';

export const WHWChargesDisclaimer = (props) => {
  const {spoCategoryCodeList, isSPO} = props;
  if(!(isWHWPhase2Flag() && isWHWPlusSPO(spoCategoryCodeList))){
    return null
  }
  const diclaimerText = isSPO ? 'Charges are based on the estimated delivery date of the extender(s).' 
    : 'Discounts are based on the estimated delivery date of the extender(s).';

  return (
    <Subtext>{diclaimerText}</Subtext>
  )
}

WHWChargesDisclaimer.propTypes = {
    spoCategoryCodeList: PropTypes.array,
    isSPO: PropTypes.bool,
};